import {
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderProps,
  SliderThumb,
  SliderTrack,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

interface Props extends SliderProps {
  countProgress: number;
}

export const ProgressStatusProfile = ({ countProgress, ...rest }: Props) => {
  const [sliderValue, setSliderValue] = useState<number>(0);
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  useEffect(() => {
    setSliderValue(countProgress);
  }, [countProgress]);

  return (
    <Slider
      id="slider"
      size={"sm"}
      value={sliderValue}
      min={0}
      max={100}
      colorScheme="teal"
      onChange={(v) => setSliderValue(v)}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      isReadOnly
      {...rest}
    >
      <SliderMark value={25} mt="1" ml="-2.5" textStyle={"b-reg"}>
        25%
      </SliderMark>
      <SliderMark value={50} mt="1" ml="-2.5" textStyle={"b-reg"}>
        50%
      </SliderMark>
      <SliderMark value={75} mt="1" ml="-2.5" textStyle={"b-reg"}>
        75%
      </SliderMark>
      <SliderTrack>
        <SliderFilledTrack />
      </SliderTrack>

      <Tooltip
        hasArrow
        bg="teal.500"
        color="white"
        placement="top"
        isOpen={showTooltip}
        label={`${sliderValue}%`}
      >
        <SliderThumb />
      </Tooltip>
    </Slider>
  );
};
